import Axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Steps, Button, message, Modal } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import GuidePage from './Sections/GuidePage';
import FixedQuestionPage from './Sections/FixedQuestionPage';
import SubmitSurveyPage from './Sections/SubmitSurveyPage';
const { Step } = Steps;
const { confirm } = Modal;

export const UserContext = React.createContext();

function NewTakeSurveyPage(props) {
  // const [tokenInfo, setTokenInfo] = useState();
  // const [questionInfo, setQuestionInfo] = useState([]);
  // const [stepArr, setStepArr] = useState([]);
  const [current, setCurrent] = useState(0);
  const [answer, setAnswer] = useState({});
  const [disableBtn, setDisableBtn] = useState(true);
  const [saveStatus, setSaveStatus] = useState(''); // 保存状態の表示用
  const [isLoadingTemp, setIsLoadingTemp] = useState(true); // 一時保存データ読み込み中フラグ

  const studyStartDate = Date.now();
  const { stepArr } = props.location.state;
  const { tokenInfo } = props.location.state;
  const { questionInfo } = props.location.state;
  // const { questionSet } = props.location.state;
  tokenInfo.user = props.user.userData;
  tokenInfo.questionSet = props.location.state.questionSet;
  tokenInfo.seasonInfo = props.location.state.seasonInfo;
  const queLen = questionInfo.length;

  // Context値に保存状態とcurrentを追加
  const value = {
    answer,
    setAnswer,
    current,
    setCurrent,
    saveStatus,
    setSaveStatus,
  };

  // console.log({ questionInfo });
  // console.log({ props });

  let steps = [
    // ...stepArr,
    {
      key: 0,
      title: '案内',
      content: <GuidePage tokenInfo={tokenInfo} />,
    },
  ];

  for (let i = 0; i < stepArr.length; i++) {
    const element = stepArr[i];
    steps.push({
      key: i + 1,
      title: '',
      content: (
        <UserContext.Provider value={value}>
          <FixedQuestionPage
            tokenInfo={tokenInfo}
            section={element.section}
            questionInfo={element.questionInfo}
          />
        </UserContext.Provider>
      ),
    });
  }

  steps.push({
    key: stepArr.length + 1,
    title: '提出',
    content: (
      <UserContext.Provider value={value}>
        <SubmitSurveyPage
          props={props}
          tokenInfo={tokenInfo}
          studyStartDate={studyStartDate}
        />
      </UserContext.Provider>
    ),
  });

  const pageAnsCheck = (qi) => {
    const rq = qi.filter((item) => item.required === true);
    // console.log({ rq });
    // console.log({ answer });
    for (let i = 0; i < rq.length; i++) {
      if (!answer[rq[i].no]) return false;
      if (rq[i].free_after) {
        if (answer[rq[i].no] === rq[i].free_after && !answer[rq[i].no + 1000]) {
          return false;
        }
      }
    }
    return true;
  };

  const nextHandler = async () => {
    if (current !== 0) {
      const pc = pageAnsCheck(stepArr[current - 1].questionInfo);
      // console.log({ pc });
      if (pc) {
        // ページ移動前に即座に保存（次のページ番号を保存）
        await saveBeforePageChange(current + 1);
        setCurrent(current + 1);
        window.scrollTo({
          top: 0,
        });
      } else {
        message.error({
          content: '全ての必須設問にお答えください。',
          key: 'pageCheck',
          duration: 4,
        });
      }
      // console.log({ tf });
      // console.log(stepArr.length);
      // console.log({ answer });
    } else {
      // ページ移動前に即座に保存（次のページ番号を保存）
      await saveBeforePageChange(current + 1);
      setCurrent(current + 1);
      window.scrollTo({
        top: 0,
      });
    }
    const tf = checkAnswerCnt();
    setDisableBtn(tf);
  };

  const prevHandler = async () => {
    // ページ移動前に即座に保存（前のページ番号を保存）
    await saveBeforePageChange(current - 1);
    setCurrent(current - 1);
    window.scrollTo({
      top: 0,
    });
    // console.log({ answer });
  };

  // 提出（本回答保存 + ステータス更新）を冪等・自動リトライで実行する共通処理。
  // サーバの POST /api/dbModel100 を survey_token 単位の upsert（冪等）にしたため、
  // リトライしても本回答は重複作成されず、ステータス更新(=5)も冪等。
  // 一時的な失敗（タイムアウト・500 等）は指数バックオフで最大3回まで自動再試行し、
  // それでも駄目な場合のみ {success:false} を返す（従来のエラーメール安全網へ）。
  const submitAnswer = async (data) => {
    const attempts = 3;
    for (let i = 0; i < attempts; i++) {
      try {
        const res = await Axios.post('/api/dbModel100', data);
        if (!res.data.success) throw new Error('answer save failed');
        const res2 = await Axios.patch(
          `/api/surveyToken/${tokenInfo._id}/status`,
          { survey_status: 5, answer_id: res.data.dbModel100._id }
        );
        if (!res2.data.success) throw new Error('status update failed');
        return { success: true };
      } catch (err) {
        console.log(`提出試行 ${i + 1}/${attempts} 失敗:`, err && err.message);
        // 最終試行以外は指数バックオフ（0.8s → 1.6s）で再試行
        if (i < attempts - 1) {
          await new Promise((r) => setTimeout(r, 800 * Math.pow(2, i)));
        }
      }
    }
    return { success: false, sendData: data };
  };

  const ansSendHandler = async () => {
    let sendData = {};
    try {
      // console.log({ tokenInfo });
      let ansArr = [];
      // console.log(surveyDBURL[tokenInfo.survey_code]);
      // const res = await Axios.post('/api/dbModel300', data);
      switch (tokenInfo.survey_code) {
        //人事評価力診断　→まだここには来ない「takesurvey」に行く
        //時間があるときに統合

        // case '50010':
        // for (let i = 1; i < queLen + 1; i++) {
        //   ansArr.push(answer[i]);
        // }
        // const data500 = {
        //   user: tokenInfo.user._id,
        //   survey_token: tokenInfo._id,
        //   study_end_date: Date.now(),
        //   study_start_date: studyStartDate,
        //   answers: ansArr,
        // };
        // const res500 = await Axios.post('/api/dbModel100', data500);
        // if (res500.data.success) {
        //   const res3 = await Axios.patch(
        //     `/api/surveyToken/${tokenInfo._id}/status`,
        //     {
        //       survey_status: 5,
        //       answer_id: res500.data.dbModel100._id,
        //     }
        //   );
        //   // console.log({ res3 });
        //   if (res3.data.success) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }
        case '10010':
        case '50010':
        case '50020':
        case '50030':
        case '50040':
        case '60010':
        case '60020':
          // let ansLen = Object.keys(answer).length;
          for (let i = 1; i < queLen + 1; i++) {
            ansArr.push(answer[i]);
          }
          const data100 = {
            user: tokenInfo.user._id,
            survey_token: tokenInfo._id,
            study_end_date: Date.now(),
            study_start_date: studyStartDate,
            answers: ansArr,
          };
          sendData = data100;
          return await submitAnswer(data100);
        // }
        //E3-Survey
        case '30010':
        case '70010':
        case '80010':
          // let ansLen = Object.keys(answer).length;
          for (let i = 1; i < queLen + 1; i++) {
            if (answer[i]) {
              ansArr.push(answer[i].toString());
            } else {
              ansArr.push('');
            }
          }
          const data300 = {
            user: tokenInfo.user._id,
            survey_token: tokenInfo._id,
            study_end_date: Date.now(),
            study_start_date: studyStartDate,
            answers: ansArr,
          };
          sendData = data300;
          return await submitAnswer(data300);
        //研修前後アンケート
        case '20110':
        case '20210':
        case '40010':
          // let ansLen = Object.keys(answer).length;
          for (let i = 1; i < queLen + 1; i++) {
            if (answer[i]) {
              if (answer[i + 1000]) {
                ansArr.push(answer[i] + ' : ' + answer[i + 1000].toString());
              } else if (answer[i + 3000]) {
                ansArr.push(answer[i] + ' : ' + answer[i + 3000].toString());
              } else {
                ansArr.push(answer[i].toString());
              }
            } else {
              ansArr.push('');
            }
          }
          const data201 = {
            user: tokenInfo.user._id,
            survey_token: tokenInfo._id,
            study_end_date: Date.now(),
            study_start_date: studyStartDate,
            answers: ansArr,
          };
          sendData = data201;
          return await submitAnswer(data201);
        default:
          break;
      }
    } catch (error) {
      console.log(error);
      return { success: false, sendData: sendData };
    }
  };

  const showConfirm = async () => {
    confirm({
      title: '回答を提出しますか？',
      content:
        '提出処理が完了し、マイ・サーベイページへ自動遷移されるまで、そのままお待ちください。',
      async onOk() {
        // return new Promise((resolve, reject) => {
        //   setTimeout(Math.random() > 0 ? resolve : reject, 3000);
        //   ansSendHandler();
        // }).catch(() => console.log('サーベイ結果提出でエラーが発生しました。'));
        const result = await ansSendHandler();
        if (result.success) {
          // 最終提出成功時、一時保存データを削除
          try {
            await Axios.delete(`/api/tempAnswer/${tokenInfo._id}`);
            console.log('一時保存データを削除しました');
          } catch (error) {
            console.error('一時保存データの削除エラー:', error);
            // 削除が失敗しても続行
          }

          message.success('回答を提出しました。マイ・サーベイに戻ります。');
          // console.log({ answer });
          // console.log({ tokenInfo });
          // sendErrorMailHandler(
          //   JSON.stringify({ answer, tokenInfo }, null, '\t')
          // );
          // message.error({
          //   content:
          //     'サーベイ回答提出でエラーを感知しました。【回答データ】をバックアップしましたのでご安心ください。事務局から復元結果をメールで案内しますのでお待ちください。',
          //   key: 'answerError',
          //   duration: 100,
          // });
          props.history.push('/mysurvey');
        } else {
          console.log({ answer });
          sendErrorMailHandler(
            JSON.stringify(
              { answer, tokenInfo, sendData: result.sendData },
              null,
              '\t'
            )
          );
          message.error({
            content:
              'サーベイ回答提出でエラーを感知しました。【回答データ】はバックアップしましたのでご安心ください。事務局から復元結果をメールでご案内しますのでお待ちください。',
            key: 'answerError',
            duration: 60,
          });
          props.history.push('/mysurvey');
        }
      },
      async onCancel() {},
    });
  };

  //結果提出ボタンのDisable;true or false変換
  const checkAnswerCnt = (answerData) => {
    // 引数がない場合は現在のanswerを使用
    const targetAnswer = answerData || answer;

    let newAnswer = {};
    for (let key in targetAnswer) {
      if (targetAnswer[key]) {
        newAnswer[key] = targetAnswer[key];
      }
    }
    // console.log({ newAnswer });
    const arr = Object.keys(newAnswer);
    const unreqQNo = []; //任意の設問番号をArrに格納
    let answerFreeAfter = true; //選択＋自由記述型の返事結果
    for (let i = 0; i < questionInfo.length; i++) {
      const element = questionInfo[i];
      if (!element.required) {
        unreqQNo.push(element.no.toString());
      }
      if (element.free_after && element.required) {
        //必須の選択＋自由記述形を絞る
        if (targetAnswer[element.no] === element.free_after) {
          //その答えがその他を選択した場合
          if (targetAnswer[element.no + 1000]) {
            // console.log(`回答あり：${targetAnswer[element.no + 1000]}`);
          } else {
            answerFreeAfter = false;
            // console.log(
            //   `回答なし：${element.no}問目の回答が${targetAnswer[element.no]}なのに`
            // );
          }
        }
      }
    }
    // console.log({ arr });
    //E3-Survey・360の場合は自由記述型は任意に処理
    if (
      tokenInfo.survey_code === '30010' ||
      tokenInfo.survey_code === '40010'
    ) {
      const arr2 = arr.filter(
        (item) => !unreqQNo.includes(item) //任意の設問番号が一致しない場合のみカウント
        // (item) =>
        //   item !== '31' && item !== '62' && item !== '93' && item !== '124' //自由記述設問をカウントしない
      );
      if (queLen - unreqQNo.length > arr2.length) {
        return true; //提出ボタン非表示
      } else {
        return false;
      }
    } else if (
      tokenInfo.survey_code === '20110' ||
      tokenInfo.survey_code === '20210'
    ) {
      // console.log({ arr });

      // console.log({ arr });
      const arr2 = arr.filter(
        (item) => !unreqQNo.includes(item) && Number(item) < 1000 //任意の設問番号が一致しない場合と1000以上を除いてカウント
      );
      // console.log({ answerFreeAfter });
      if (queLen - unreqQNo.length > arr2.length || !answerFreeAfter) {
        return true; //提出ボタン非表示
      } else {
        return false;
      }
    } else {
      if (queLen !== arr.length) {
        return true; //提出ボタン非表示
      } else {
        return false;
      }
    }
  };

  // 一時保存データの読み込み
  useEffect(() => {
    const loadTempAnswers = async () => {
      try {
        setIsLoadingTemp(true);
        const response = await Axios.get(`/api/tempAnswer/${tokenInfo._id}`);

        if (response.data.success && response.data.tempAnswer) {
          const tempData = response.data.tempAnswer;

          // 保存された回答データを復元
          setAnswer(tempData.answers || {});

          // 保存されたページ位置を復元
          if (tempData.current_page && tempData.current_page > 0) {
            setCurrent(tempData.current_page);
            message.info({
              content: '前回の作業内容を復元しました',
              key: 'restore',
              duration: 3,
            });
          }

          // 提出ボタンの状態を更新
          const tf = checkAnswerCnt(tempData.answers || {});
          setDisableBtn(tf);
        }
      } catch (error) {
        console.log('一時保存データの読み込みエラー:', error);
        // エラーが発生しても続行（新規開始として扱う）
      } finally {
        setIsLoadingTemp(false);
      }
    };

    loadTempAnswers();
  }, []); // 初回レンダリング時のみ実行

  // ページ移動時の即座保存関数
  const saveBeforePageChange = async (nextPage) => {
    try {
      await Axios.post('/api/tempAnswer/save', {
        user: tokenInfo.user._id,
        survey_token: tokenInfo._id,
        current_page: nextPage !== undefined ? nextPage : current,
        answers: answer,
      });
    } catch (error) {
      console.error('ページ移動時の保存エラー:', error);
    }
  };

  const sendErrorMailHandler = async (data) => {
    let mailList = {};
    try {
      // console.log({ rowKeys });
      // const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      // const res = await Axios.get(`/api/mailTemplate/tempw`);
      // const selMtInfo = res.data.mailTemplate;
      // console.log({ selMtInfo });
      // console.log({ data });
      mailList = {
        personalizations: [
          {
            to: [
              {
                email: 'retech@re-current.co.jp',
                name: `リ・カレントサーベイ事務局`,
              },
              {
                email: 'skim@re-current.co.jp',
                name: `リ・カレントサーベイ事務局`,
              },
            ],
            bcc: { email: 'admin365@re-current.co.jp' },
            substitutions: {},
          },
        ],
        from: {
          email: 'retech@re-current.co.jp', // 送信元アドレス
          name: `リ・カレントサーベイ事務局`, // 送信者名
        },
        subject:
          '【サーベイ・エラー】サーベイ・エラーが発生しました。（システムテストです）',
        html: data,
        headers: {
          'X-Sent-Using': 'SendGrid-API',
        },
      };
      // console.log({ mailList });
      // const sendMailResult = { data: { success: false } };
      const sendMailResult = await Axios.post('/api/sendMail', {
        mailList: mailList,
        operation_log: 'AnswerErrorMailSend',
      });
      if (sendMailResult.data.success) {
        message.success({
          content: 'メール送信完了！',
          key: 'mail',
          duration: 2,
        });
        return sendMailResult;
      } else {
        message.error({
          content: 'メール送信に失敗しました。',
          key: 'mail',
          duration: 2,
        });
        console.log({ sendMailResult });
        throw new Error('メール送信に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  return (
    <div style={{ width: '90%', margin: '0rem auto' }}>
      <div style={{ marginTop: 16, marginBottom: 16 }}>
        {/* 2 次トラック S5・企画 item 15: ステップ進捗をデザインポリシー
            （ショーケース §26）へ整合。文字（ラベル）を番号の「下」に配置
            （labelPlacement="vertical"）。済みステップの色味（控えめなグレー）は
            index.css の .ant-steps オーバーライドで担う（<Steps> 使用は本画面のみ）。 */}
        <Steps current={current} labelPlacement="vertical">
          {steps.map((item) => (
            <Step key={item.key} title={item.title} />
          ))}
        </Steps>
        {/* 保存状態の表示 */}
        {saveStatus && (
          <div
            style={{
              textAlign: 'right',
              marginTop: 8,
              marginBottom: 8,
              color:
                saveStatus === '保存済み ✓'
                  ? '#52c41a'
                  : saveStatus === '保存失敗'
                  ? '#ff4d4f'
                  : 'var(--blue-active)',
              fontSize: '12px',
            }}
          >
            {saveStatus}
          </div>
        )}
        {/* 案内（ガイド=step0）は GuideContent 内のカードで白背景を持つため、
            外側のステップ領域は質問・提出ステップと同じ cream 背景に揃える。 */}
        <div
          className={
            current === 0 ? 'steps-content steps-content--guide' : 'steps-content'
          }
        >
          {steps[current].content}
        </div>
        <div className="steps-action">
          {current > 0 && (
            <Button
              size="large"
              onClick={prevHandler}
            >
              前へ
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button type="primary" size="large" onClick={nextHandler}>
              次へ
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              danger
              shape="round"
              icon={<CloudUploadOutlined />}
              size="large"
              onClick={showConfirm}
              disabled={disableBtn}
            >
              回答提出
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewTakeSurveyPage;

//일단 백업
// const readDB = async () => {
//   try {
// const res = await Axios.get(`/api/surveyToken/t/${tokenId}`);
// // console.log(res);
// if (res.data.success) {
//   const { tokenInfo } = res.data;
//   setTokenInfo(tokenInfo);
//   //question_set_id：あり→可変問題構成
//   //question_set_id：なし→固定問題構成
//   if (tokenInfo.question_set_id) {
//     // console.log('あり');
//     //可変問題構成方式
//   } else {
//     // console.log('なし');
//     //固定問題構成方式
//     const res2 = await Axios.get(
//       `/api/question/${tokenInfo.survey_code}`
//     );
//     if (res2.data.success) {
//       const questionInfo = res2.data.question;
//       setQuestionInfo(questionInfo);
//       console.log({ questionInfo });
//       //Section情報のみ数字で取り出してSortをかける
//       const secNum = [
//         ...new Map(
//           await questionInfo.map((info) => [
//             info.section,
//             Number(info.section),
//           ])
//         ).values(),
//       ].sort((first, second) => first - second);
//       console.log(secNum);
//       // secNum.forEach((secNum) => {
//       for (let i = 0; i < secNum.length; i++) {
//         const element = secNum[i];
//         steps.push({
//           title: `${element}ページ`,
//           content: `${element}コンテンツ`,
//         });
//       }
//       // setStepArr([
//       //   ...stepArr,
//       //   {
//       //     title: `${secNum}ページ`,
//       //     content: `${secNum}コンテンツ`,
//       //   },
//       // ]);
//       // });
//       // steps = stepArr;
//       console.log(steps);
//     } else {
//       throw '問題情報取得に失敗しました。';
//     }
//   }
// } else {
//   throw 'サーベイトークン情報取得に失敗しました。';
// }
//   } catch (error) {
//     console.log(error);
//   }
// };

// useEffect(() => {
//   readDB();
//   // console.log(steps);
// }, []);
